import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=c57041d8&scoped=true&lang=pug&"
import script from "./Book.vue?vue&type=script&lang=js&"
export * from "./Book.vue?vue&type=script&lang=js&"
import style0 from "./Book.styl?vue&type=style&index=0&id=c57041d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57041d8",
  null
  
)

export default component.exports